import React from 'react';
import { FreeConsultLink } from './FreeConsultLink';
import { CheckCircleIcon, SearchIcon, TargetIcon, BuildingIcon, DogIcon } from 'lucide-react';
export const Solution = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-597">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-598">
        De doorbraak: Onze 3-stappen methode
      </h2>
      <div className="bg-green-50 p-6 rounded-lg mb-8 border-l-4 border-green-500" data-id="element-599">
        <p className="mb-4 leading-relaxed" data-id="element-600">
          Na jaren van onderzoek en honderden succesvolle trajecten hebben we
          een methode ontwikkeld die verlatingsangst oplost door de échte
          oorzaak aan te pakken.
        </p>
        <a href="https://training.stresslessdogs.nl/va-video" className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition duration-200" data-id="element-601">
          <DogIcon className="w-5 h-5 mr-2" data-id="element-602" />
          Aanmelden voor hulp bij verlatingsangst
        </a>
      </div>
      <div className="space-y-8 mb-8" data-id="element-603">
        <div className="flex" data-id="element-604">
          <div className="bg-blue-600 text-white rounded-full min-w-10 h-10 flex items-center justify-center font-bold mr-4 flex-shrink-0" data-id="element-605">
            1
          </div>
          <div data-id="element-606">
            <h3 className="font-bold text-lg mb-2 flex items-center" data-id="element-607">
              <SearchIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-608" />
              De diagnose
            </h3>
            <p className="mb-3 leading-relaxed" data-id="element-609">
              <strong data-id="element-610">Waarom diagnose cruciaal is:</strong> Je kunt geen
              probleem oplossen dat je niet begrijpt.
            </p>
            <p className="mb-3 leading-relaxed" data-id="element-611">
              Onze uitgebreide analyse bestaat uit:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-3" data-id="element-612">
              <li data-id="element-613">
                Gedragsobservatie via huisdiercamera - We zien hoe je hond zich
                echt gedraagt als je weg bent
              </li>
              <li data-id="element-614">
                Grondige vragenlijst over geschiedenis, triggers, en dagelijkse
                routine
              </li>
              <li data-id="element-615">
                Analyse van de thuissituatie en alles wat stress kan veroorzaken
              </li>
            </ul>
            <p className="mb-3 leading-relaxed" data-id="element-616">
              We onderscheiden verschillende onderliggende oorzaken:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-617">
              <li data-id="element-618">
                <strong data-id="element-619">FOMO (Fear of Missing Out)</strong> - De hond wil overal
                bij zijn, niet specifiek bang om verlaten te worden
              </li>
              <li data-id="element-620">
                <strong data-id="element-621">Geluidsangst</strong> - Alleen thuis betekent
                confrontatie met enge geluiden
              </li>
              <li data-id="element-622">
                <strong data-id="element-623">Algemene angst</strong> - Voor de buitenwereld,
                onbekende situaties
              </li>
              <li data-id="element-624">
                <strong data-id="element-625">Verveling & frustratie</strong> - Energieke honden die
                geen uitlaatklep hebben
              </li>
              <li data-id="element-626">
                <strong data-id="element-627">Trauma</strong> - Eerdere nare ervaringen tijdens
                alleen-zijn
              </li>
            </ul>
            <p className="leading-relaxed font-semibold mt-2" data-id="element-628">
              Elke oorzaak vraagt om een compleet andere aanpak.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-629">
          <div className="bg-blue-600 text-white rounded-full min-w-10 h-10 flex items-center justify-center font-bold mr-4 flex-shrink-0" data-id="element-630">
            2
          </div>
          <div data-id="element-631">
            <h3 className="font-bold text-lg mb-2 flex items-center" data-id="element-632">
              <BuildingIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-633" />
              De juiste basis leggen
            </h3>
            <p className="mb-3 leading-relaxed" data-id="element-634">
              Eerst het onderliggende probleem aanpakken:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-3" data-id="element-635">
              <li data-id="element-636">
                <strong data-id="element-637">FOMO?</strong> De hond leren dat thuis zijn ook leuk en
                waardevol is, zelfs als hij alleen zal zijn
              </li>
              <li data-id="element-638">
                <strong data-id="element-639">Geluidsangst?</strong> Geluidstraining en desensitisatie
                eerst
              </li>
              <li data-id="element-640">
                <strong data-id="element-641">Verveling?</strong> De hond meer mentaal stimuleren
                zodat hij zich rustiger voelt
              </li>
              <li data-id="element-642">
                <strong data-id="element-643">Trauma?</strong> Vertrouwen en positieve associaties
                opbouwen
              </li>
            </ul>
            <p className="mb-3 leading-relaxed" data-id="element-644">
              Stressfactoren minimaliseren:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-645">
              <li data-id="element-646">Omgeving optimaliseren voor rust en comfort</li>
              <li data-id="element-647">Routine creëren die zekerheid geeft</li>
              <li data-id="element-648">
                Voorspelbaarheid in alles wat je doet - Vooral voorspelbaarheid
                voor je hond rondom het weggaan en thuiskomen
              </li>
            </ul>
            <p className="leading-relaxed font-semibold mt-2" data-id="element-649">
              Fundament voor succes: Alleen als de basis klopt, kan je succesvol
              oefenen.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-650">
          <div className="bg-blue-600 text-white rounded-full min-w-10 h-10 flex items-center justify-center font-bold mr-4 flex-shrink-0" data-id="element-651">
            3
          </div>
          <div data-id="element-652">
            <h3 className="font-bold text-lg mb-2 flex items-center" data-id="element-653">
              <TargetIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-654" />
              Strategisch oefenen
            </h3>
            <p className="mb-3 leading-relaxed" data-id="element-655">
              Pas als de basis stevig staat, beginnen we met oefenen - maar op
              een totaal andere manier:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-656">
              <li data-id="element-657">
                <strong data-id="element-658">Binnen de grenzen van je hond:</strong> Nooit
                overvragen, alleen positieve ervaringen creëren
              </li>
              <li data-id="element-659">
                <strong data-id="element-660">Met de juiste stappen:</strong> Gebaseerd op jouw hond's
                specifieke profiel en onderliggende probleem
              </li>
              <li data-id="element-661">
                <strong data-id="element-662">Real-time feedback:</strong> Via camera en dagelijkse
                WhatsApp begeleiding
              </li>
              <li data-id="element-663">
                <strong data-id="element-664">Voorkomen van terugval:</strong> Omdat de basis goed is
                gelegd, zijn de resultaten duurzaam
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="w-full mb-6" data-id="element-665">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wiDCSvwFyhKybmxNNxY2Cy/freepik__the-style-is-candid-image-photography-with-natural__77411.png" alt="Ontspannen labrador die rustig ligt op een tapijt in een zonnige kamer" className="w-full h-auto rounded-lg shadow-md" data-id="element-666" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-667">
          "Het resultaat: een ontspannen hond die geniet van zijn alleen-tijd"
        </p>
      </div>
      <h3 className="text-lg font-bold text-blue-800 mb-3" data-id="element-668">Waarom het werkt</h3>
      <ul className="mb-6 space-y-3" data-id="element-669">
        <li className="flex items-start" data-id="element-670">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-671" />
          <span data-id="element-672">
            <strong data-id="element-673">Wetenschappelijk onderbouwd:</strong> Gebaseerd op moderne
            hondenpsychologie
          </span>
        </li>
        <li className="flex items-start" data-id="element-674">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-675" />
          <span data-id="element-676">
            <strong data-id="element-677">Bewezen resultaten:</strong> 3 maanden gemiddeld vs jaren
            traditionele training
          </span>
        </li>
        <li className="flex items-start" data-id="element-678">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-679" />
          <span data-id="element-680">
            <strong data-id="element-681">Duurzaam:</strong> Geen terugval omdat de wortel is
            aangepakt, niet alleen de symptomen
          </span>
        </li>
      </ul>
      <h3 className="text-lg font-bold text-blue-800 mb-3" data-id="element-682">
        Het intake proces
      </h3>
      <p className="mb-3 leading-relaxed" data-id="element-683">
        <strong data-id="element-684">Eerste stap:</strong> Gratis intake gesprek (45-60 minuten)
      </p>
      <p className="mb-3 leading-relaxed" data-id="element-685">Wat bespreken we:</p>
      <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-686">
        <li data-id="element-687">Jouw specifieke situatie in detail</li>
        <li data-id="element-688">Of het wel echt een vorm van verlatingsangst is</li>
        <li data-id="element-689">Of we zeker weten dat we resultaat kunnen garanderen</li>
      </ul>
      <p className="mb-3 leading-relaxed" data-id="element-690">
        <strong data-id="element-691">Waarom zo uitgebreid:</strong> Resultaat hangt af van zowel de
        problematiek van de hond als hoe het baasje ermee om wil gaan - beiden
        moeten goed zijn voordat we resultaat garanderen.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-692">
        <strong data-id="element-693">Vrijblijvend en kosteloos:</strong> Geen verplichtingen, alleen
        duidelijkheid.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-694">
        <FreeConsultLink onClick={openModal} data-id="element-695">
          Plan je gratis intake gesprek
        </FreeConsultLink>{' '}
        en ontdek wat er écht speelt bij jouw hond.
      </p>
    </section>;
};